export default {
    message: {
        calculator: {
            btn1_link: "/en-in/products/citrix-workspace/form/pricing-inquiry/",
        }
    }
}